__turbopack_context__.v({
  "enterFromLeft": "desktop-module__-3uunW__enterFromLeft",
  "enterFromRight": "desktop-module__-3uunW__enterFromRight",
  "enterIntoNav": "desktop-module__-3uunW__enterIntoNav",
  "exitFromNav": "desktop-module__-3uunW__exitFromNav",
  "exitToLeft": "desktop-module__-3uunW__exitToLeft",
  "exitToRight": "desktop-module__-3uunW__exitToRight",
  "navDropdownContent": "desktop-module__-3uunW__navDropdownContent",
  "navViewport": "desktop-module__-3uunW__navViewport",
});
